import flatpickr from "flatpickr";
import { Slovak } from "flatpickr/dist/l10n/sk"

export const initDatepickers = () => {
    const elements = [...document.querySelectorAll('.datepicker')].filter(el => !el.classList.contains('is-datepicker-initialized'))

    for (const el of elements) {
        el.setAttribute('autocomplete', 'off')

        flatpickr(el, {
            disableMobile: true,
            allowInput: true,
            locale: Slovak,
            dateFormat: 'd.m.Y'
        })

        el.classList.add('is-datepicker.initialized')
    }
}
export const initDatepickerRanges = () => {
    const elements = [...document.querySelectorAll(".js-datepicker-range")].filter(
        (el) => !el.classList.contains("is-datepicker-range-initialized")
    );

    const defaultConfig = {
        disableMobile: true,
        dateFormat: "d.m.Y",
        mode: "range",
        altInput: true,
        altFormat: "j.n.Y",
        locale: "sk",
    };

    for (const el of elements) {
        el.setAttribute("autocomplete", "off");

        // Get custom config from data attribute if exists
        const customConfig = el.dataset.flatpickr ? JSON.parse(el.dataset.flatpickr) : {};

        const startDateHidden = document.getElementById("filter-from");
        const endDateHidden = document.getElementById("filter-to");
        const clearBtn = document.querySelector(".js-clear-date-range");

        // the hidden inputs hold Y-m-d, flatpickr would parse them with dateFormat (d.m.Y)
        const parseHiddenDate = (value) => {
            const [year, month, day] = value.split("-").map(Number);

            return new Date(year, month - 1, day);
        };

        const initialDates = [];
        // Check if both hidden inputs have a value on page load.
        if (startDateHidden.value && endDateHidden.value) {
            initialDates.push(parseHiddenDate(startDateHidden.value));
            initialDates.push(parseHiddenDate(endDateHidden.value));
            clearBtn.classList.remove("hidden");
        }

        // Initialize flatpickr with merged config
        const fp = flatpickr(el, {
            ...defaultConfig,
            ...customConfig,
            defaultDate: initialDates,
            onClose: function (selectedDates, dateStr, instance) {
                // Check if a valid range (two dates) has been selected
                if (selectedDates.length === 2) {
                    startDateHidden.value = instance.formatDate(selectedDates[0], "Y-m-d");
                    endDateHidden.value = instance.formatDate(selectedDates[1], "Y-m-d");
                    // A range is selected, so show the clear button
                    clearBtn.classList.remove("hidden");
                } else if (selectedDates.length === 0) {
                    startDateHidden.value = "";
                    endDateHidden.value = "";
                    // The selection was cleared, so hide the button
                    clearBtn.classList.add("hidden");
                }

                const event = document.createEvent("Event");
                event.initEvent("change", true, true);
                startDateHidden.dispatchEvent(event);
            },
        });

        clearBtn.addEventListener("click", function () {
            fp.clear();
            startDateHidden.value = "";
            endDateHidden.value = "";

            const event = document.createEvent("Event");
            event.initEvent("change", true, true);
            startDateHidden.dispatchEvent(event);

            clearBtn.classList.add("hidden");
        });

        el.classList.add("is-datepicker-range-initialized");
    }
};

